import { ExtraDataRow } from "./extra-data-row";
import { Exam } from "./exam";
import { Ajax } from "../ajax";
import { Notifications } from "../notifications";
export class CertificateExtraData {
    constructor() {
        this.fieldType = $("#field_type");
        this.nameField = $("#name");
        this.requiredField = $("#required");
        this.enumValuesField = $("#enum_values");
        this.types = {};
        this.fields = [];
        this.parentField = $("#parent");
        this.parentValueField = $("#parent-value");
        this.descriptionField = $("#description");
        this.cancelEditButton = $("#cancel-edit");
        this.addButtons = $("#add-buttons");
        this.editButtons = $("#edit-buttons");
        this.typeExtras = $(".type-extra");
        this.form = $("#save_extra_data");
        this.sending = false;
        this.exams = $("#exams");
        if ($("#save_extra_data").length !== 1) {
            return;
        }
        this.fieldType.on("change", () => this.onFieldTypeChanged());
        $("#add-row").on("click", () => this.addRow(new ExtraDataRow()));
        $("#update").on("click", () => this.addRow(this.currentRow));
        this.createTypes();
        ExtraDataRow.onEdit = (row) => this.onEdit(row);
        ExtraDataRow.onReorder = (row) => this.reorderFields(row);
        this.parentField.on("change", () => this.onParentChanged());
        this.cancelEditButton.on("click", () => this.onEditCancelled());
        this.addExistingRows();
        $("#fields").sortable({ stop: () => this.reorderFields() });
        $("#save").on("click", () => this.save());
        this.exams.select2();
        this.form.on("submit", (event) => {
            event.preventDefault();
            this.addRow(this.currentRow === undefined ? new ExtraDataRow() : this.currentRow);
        });
    }
    createTypes() {
        this.fieldType.find("option").each((index, item) => {
            const id = $(item).val();
            if (id === "") {
                return;
            }
            this.types[id] = {
                id: parseInt(id),
                name: $(item).html(),
                parentPossible: !!$(item).data("parentPossible"),
                isEnum: !!$(item).data("isEnum"),
                isCheckbox: !!$(item).data("isCheckbox"),
            };
        });
    }
    onFieldTypeChanged() {
        this.typeExtras.addClass("hidden");
        this.typeExtras
            .filter(`.type-${this.fieldType.val()}`)
            .removeClass("hidden");
    }
    addRow(row) {
        const name = this.nameField.val();
        if (!name) {
            Notifications.error(this.nameField.data("requiredMessage"));
            return;
        }
        const enumValues = this.currentEnumValues;
        const type = this.currentType;
        if (type === undefined || enumValues === undefined) {
            return;
        }
        if (this.currentRow === undefined) {
            this.fields.push(row);
        }
        row.name = name;
        row.type = type;
        row.required = this.requiredField.prop("checked");
        row.enumValues = enumValues;
        row.description = this.currentDescription;
        const { currentParent } = this;
        if (row.parent !== currentParent) {
            row.order = this.nextOrder(currentParent);
            row.setParent(currentParent, this.parentValueField.val());
        }
        row.exams.clear();
        this.exams.select2("data").forEach((data) => {
            row.exams.add(new Exam(data.id, data.text));
        });
        this.attach(row);
        row.updateHtml();
        this.addButtons.removeClass("hidden");
        this.editButtons.addClass("hidden");
        this.currentRow = undefined;
        this.fillParents();
        this.clearForm();
    }
    attach(row) {
        let fallbackParent;
        let fields = [];
        if (!row.parent) {
            fallbackParent = $("#fields");
            fields = this.fields;
        }
        else {
            fallbackParent = row.parent.childrenWrapper;
            fields = row.parent.children;
        }
        const previous = this.getPrevious(row.order, fields);
        row.attachWrapper(previous === undefined ? fallbackParent : previous);
    }
    getPrevious(order, fields) {
        let previous;
        for (const field of fields) {
            const difference = order - field.order;
            if ((previous === undefined || field.order >= previous.order) &&
                difference > 0 &&
                difference < 99) {
                previous = field;
            }
        }
        return previous;
    }
    nextOrder(parent) {
        let last = parent === undefined ? 10 : parent.firstChildOrder - 1;
        const fields = parent === undefined ? this.fields : parent.children;
        for (const row of fields) {
            if (row.order > last && row.order - last < 99) {
                last = row.order;
            }
        }
        return last + 1;
    }
    get currentDescription() {
        return this.descriptionField.val();
    }
    get currentParent() {
        const selected = this.parentField.find("option:selected");
        return selected.data("field");
    }
    fillParents(currentRow) {
        this.parentField.find("option").remove();
        this.parentField.append(`<option value="">${alwaysMessage}</option>`);
        const whenValueMessage = this.parentField.data("whenValue");
        for (const field of this.fields) {
            if (field.type.parentPossible && currentRow !== field) {
                let selected = "";
                if (currentRow !== undefined && field === currentRow.parent) {
                    selected = ' selected="selected"';
                }
                const message = whenValueMessage.replace("{fieldName}", field.name);
                const option = $(`<option${selected}>"${message}"</option>`);
                option.data("field", field);
                this.parentField.append(option);
            }
        }
        this.parentField.trigger("change");
    }
    get currentType() {
        return this.findType(this.fieldType.val());
    }
    findType(typeId) {
        if (!typeId || !(typeId in this.types)) {
            Notifications.error(this.fieldType.data("requiredMessage"));
            return undefined;
        }
        return this.types[typeId];
    }
    get currentEnumValues() {
        const type = this.currentType;
        if (type === undefined) {
            return undefined;
        }
        const enumValues = [];
        if (type.isEnum) {
            this.enumValuesField.find("option").each((index, item) => {
                enumValues.push($(item).html());
            });
            if (enumValues.length === 0) {
                Notifications.error(this.enumValuesField.data("requiredMessage"));
                return undefined;
            }
        }
        return enumValues;
    }
    clearForm() {
        this.nameField.val("");
        this.requiredField.prop("checked", false);
        this.fieldType.val("").trigger("change");
        this.enumValuesField.tagsinput("removeAll");
        this.descriptionField.val("");
        this.parentField.val("").trigger("change");
        this.exams.val(null).trigger("change");
    }
    onEdit(row) {
        this.currentRow = row;
        this.addButtons.addClass("hidden");
        this.editButtons.removeClass("hidden");
        this.nameField.val(row.name);
        this.descriptionField.val(row.description);
        this.requiredField.prop("checked", row.required);
        this.fieldType.val(row.type.id).trigger("change");
        for (const value of row.enumValues) {
            this.enumValuesField.tagsinput("add", value);
        }
        this.fillParents(row);
        this.parentValueField.val(row.valueParent).trigger("change");
        this.exams.val(row.exams.getIdsArray()).trigger("change");
    }
    onEditCancelled() {
        this.currentRow = undefined;
        this.addButtons.removeClass("hidden");
        this.editButtons.addClass("hidden");
        this.clearForm();
    }
    onParentChanged() {
        const field = this.currentParent;
        if (field === undefined) {
            this.parentValueField.addClass("hidden");
        }
        else {
            this.parentValueField.removeClass("hidden");
            this.fillParentValueVisible(field);
        }
    }
    fillParentValueVisible(row) {
        this.parentValueField.find("option").remove();
        if (row.type.isEnum) {
            for (const value of row.enumValues) {
                this.parentValueField.append($(`<option value="${value}">${value}</option>`));
            }
        }
        else if (row.type.isCheckbox) {
            this.parentValueField.append($('<option value="1">marcado</option>'));
            this.parentValueField.append($('<option value="0">desmarcado</option>'));
        }
    }
    addExistingRows() {
        const rows = {};
        const waitingForParent = {};
        for (const row of existingRows) {
            const dataRow = new ExtraDataRow(row);
            dataRow.type = this.findType(row.type);
            this.fields.push(dataRow);
            rows[row.id] = dataRow;
            if (row.parentId) {
                if (row.parentId in rows) {
                    dataRow.setParent(rows[row.parentId]);
                    this.attach(dataRow);
                }
                else {
                    if (!(row.parentId in waitingForParent)) {
                        waitingForParent[row.parentId] = [];
                    }
                    waitingForParent[row.parentId].push(dataRow);
                }
            }
            else {
                this.attach(dataRow);
            }
            if (row.id in waitingForParent) {
                for (const waitingRow of waitingForParent[row.id]) {
                    waitingRow.setParent(dataRow);
                    waitingRow.updateHtml();
                    this.attach(waitingRow);
                }
                delete waitingForParent[row.id];
            }
            dataRow.updateHtml();
        }
        this.fillParents();
    }
    reorderFields(row) {
        let nextOrder = row === undefined ? 11 : row.firstChildOrder;
        const wrapper = row === undefined ? $("#fields") : row.childrenWrapper;
        wrapper.children(".field").each((index, element) => {
            const child = $(element).data("row");
            child.order = nextOrder++;
            this.reorderFields(child);
        });
    }
    save() {
        if (this.sending) {
            return;
        }
        this.disableForm();
        const ajax = new Ajax(this.form.attr("action"));
        ajax.data = { fields: JSON.stringify(this.dataForAjax) };
        ajax.successCallback = (data) => {
            this.sending = false;
            if (!data.error) {
                Notifications.successCookie(this.form.data("savedMessage"));
                window.history.back();
            }
            this.enableForm();
        };
        ajax.errorCallback = (data) => {
            this.sending = false;
            this.enableForm();
        };
        ajax.send();
    }
    get dataForAjax() {
        const fields = [];
        for (const field of this.fields) {
            if (field.parent === undefined) {
                fields.push(field.dataForAjax);
            }
        }
        return fields;
    }
    enableForm() {
        this.form.find(":input").prop("disabled", false);
    }
    disableForm() {
        this.form.find(":input").prop("disabled", true);
    }
}
